import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const AuthenticationGuard = ({ children, requiredRole = null }) => {
  const { isAuthenticated, userRole, loading, profileLoading, isProfileVerified } = useAuth();
  const location = useLocation();

  if (loading || profileLoading) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
          <p className="text-sm text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login-screen" state={{ from: location }} replace />;
  }

  // Redirect unverified non-admin users to profile verification
  // Skip if already on the verification screen to avoid redirect loop
  if (!isProfileVerified && userRole !== 'admin' && location?.pathname !== '/profile-verification-screen') {
    return <Navigate to="/profile-verification-screen" replace />;
  }

  if (requiredRole && userRole !== requiredRole) {
    const redirectPath = userRole === 'brand' ? '/brand-dashboard' :
                        userRole === 'admin' ? '/admin-panel' : '/user-dashboard';
    return <Navigate to={redirectPath} replace />;
  }

  return <>{children}</>;
};

export default AuthenticationGuard;